import { Exception } from './Exception';
export class ProductException extends Exception {
  constructor(url, params, responseException) {
    super(`path: ${url} params: ${JSON.stringify(params)} message: ${responseException.message}`);
    this.url = url;
    this.params = params;
    this.responseException = responseException;
    this.name = 'ProductException - ' + responseException.name;
  }
}
